import React from 'react';
import { Sparkles } from 'lucide-react';

export default function FindBestFitButton({ variant = 'primary', className = '', onClick, dataTestId = 'open-best-fit-quiz' }) {
  const styles = variant === 'primary'
    ? 'bg-splash-coral hover:bg-splash-coralDark text-white'
    : 'bg-white border border-splash-sand hover:bg-splash-cream text-splash-green';
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={dataTestId}
      className={`inline-flex items-center gap-2 rounded-full px-5 py-3 font-semibold btn-transition ${styles} ${className}`}
    >
      <Sparkles className="w-4 h-4" /> Find the Best Fit
    </button>
  );
}
